import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiPostAuth } from "../../utils/api"; // Use your axios wrapper
import "../../App.css";

export default function MemberListPage() {
  const [loading, setLoading] = useState(true);
  const [members, setMembers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApps = async () => {
      try {
        const response = await apiPostAuth("member/member_list.php");
        if (response.result === 1 && Array.isArray(response.member_list)) {
          setLoading(false);
          setMembers(response.member_list);
        } else {
          setMembers([]);
        }
      } catch (error) {
        setMembers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchApps();
  }, []);

  const handleAddMember = () => {
    navigate("/dashboard/member/create");
  };

  const handleOpenMemberDetail = (memberId) => {
    navigate(`/dashboard/member/${memberId}`);
  };

  const formatRegisteredDate = (dateString) => {
    if (!dateString || dateString.length < 14) return "-";

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    const hour = dateString.slice(8, 10);
    const minute = dateString.slice(10, 12);
    const second = dateString.slice(12, 14);

    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);

    return date.toLocaleString("id-ID", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
        <h1 style={{ fontSize: "1.8rem", color: "#1f2937", margin: 0 }}>
          Daftar Member MoriDapin
        </h1>
      </div>
      <p style={{ fontSize: "1rem", marginBottom: "20px", color: "#4b5563" }}>
        Berikut adalah daftar member aktif di MoriDapin
      </p>

      {/* Add App member always visible below header */}
      <button
        onClick={handleAddMember}
        className="primary-button"
        style={{
          width: "160px",
          textAlign: "center",
          marginBottom: "30px",
        }}
      >
        + Tambah Member
      </button>

      {loading ? (
        <div style={{ textAlign: "center", marginTop: "80px" }}>
          <div className="loading-spinner"></div>
          <p style={{ marginTop: "12px", color: "#4b5563" }}>Memuat daftar member...</p>
        </div>
      ) : members.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            marginTop: "40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              fontSize: "1.1rem",
              marginBottom: "20px",
              color: "#374151",
              maxWidth: "400px",
            }}
          >
            Belum ada member.<br />
            Mulai tambahkan member.
          </p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          {members.map((member) => (
            <div
              key={member.member_id}
              style={{
                backgroundColor: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "15px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <img
                  src={member.profile_picture}
                  alt={member.full_name}
                  style={{
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "1px solid #e5e7eb",
                  }}
                />

                <div>
                  <h3
                    style={{
                      fontSize: "1.2rem",
                      margin: "0 0 5px 0",
                      color: "#1f2937",
                    }}
                  >
                    {member.full_name}
                  </h3>
                  <div
                    style={{
                      ...statusBadgeStyle,
                      backgroundColor: member?.is_active === 1 ? "#dcfce7" : "#fee2e2",
                      color: member?.is_active === 1 ? "#166534" : "#991b1b",
                    }}
                  >
                    {member?.is_active === 1 ? "Aktif" : "Tidak Aktif"}
                  </div>

                  <p
                    style={{
                      fontSize: "0.9rem",
                      margin: "0",
                      color: "#6b7280",
                    }}
                  >
                    ID Member: {member.member_id}
                  </p>

                  <p
                    style={{
                      fontSize: "0.85rem",
                      margin: "5px 0 0 0",
                      color: "#6b7280",
                    }}
                  >
                    Tanggal Daftar: {formatRegisteredDate(member.registered_date)}
                  </p>
                </div>
              </div>

              <button
                onClick={() => handleOpenMemberDetail(member.member_id)}
                className="primary-button"
                style={{
                  padding: "8px 16px",
                  minWidth: "120px",
                }}
              >
                Detail Member
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


const statusBadgeStyle = {
  display: "inline-block",
  padding: "6px 10px",
  borderRadius: "999px",
  fontSize: "0.8rem",
  fontWeight: "600",
  marginTop: "5px",
  marginBottom: "5px",
};
